import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { withPrivate } from './Private'
import { Route } from 'react-router-dom'
import * as R from 'ramda'

import { enhance as withAllRoles } from 'containers/Role/Show/AllGlobalRoles'
import LoginRedirect from './utils'

const enhance = R.curryN(2, compose(
  withPrivate,
  withAllRoles
))

export default enhance(LoginRedirect)(Route)
